// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2FDMQ","title":"AfterBackImages_title__2cJI5","images":"AfterBackImages_images__2XmgG"};